import { render, staticRenderFns } from "./kycPreferences.vue?vue&type=template&id=5e0e863c&scoped=true&"
import script from "./kycPreferences.vue?vue&type=script&lang=js&"
export * from "./kycPreferences.vue?vue&type=script&lang=js&"
import style0 from "./kycPreferences.vue?vue&type=style&index=0&id=5e0e863c&scoped=true&lang=css&"
import style1 from "./kycPreferences.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e863c",
  null
  
)

export default component.exports